import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, FormInputText, InputLabel } from '@hopskipdrive/react-components';

export interface InvoiceGroupFormData {
  name: string;
  poNumber: string;
}

interface InvoiceGroupFormProps {
  formId: string;
  onSubmit: (e: React.FormEvent) => void;
}

export const InvoiceGroupForm: FC<InvoiceGroupFormProps> = ({ formId, onSubmit }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<InvoiceGroupFormData>();

  return (
    <form id={formId} onSubmit={onSubmit}>
      <Box display="flex" flexDirection="column" gap="24px">
        <Box display="flex" flexDirection="column" gap="12px">
          <InputLabel fieldtype="required" htmlFor="name">
            Invoice group name
          </InputLabel>
          <Controller
            control={control}
            name="name"
            render={({ field: { value, onChange } }) => (
              <FormInputText
                variant="outlined"
                id="name"
                name="name"
                value={value}
                data-testid="invoiceGroupName"
                fullWidth
                autoFocus
                placeholder="Enter a group name"
                error={!!errors.name}
                helperText={errors.name?.message}
                onChange={onChange}
              />
            )}
          />
        </Box>
        <Box display="flex" flexDirection="column" gap="12px">
          <InputLabel htmlFor="poNumber">Purchase order number</InputLabel>
          <Controller
            control={control}
            name="poNumber"
            render={({ field: { value, onChange } }) => (
              <FormInputText
                variant="outlined"
                id="poNumber"
                name="poNumber"
                value={value}
                data-testid="invoiceGroupPoNumber"
                fullWidth
                placeholder="Optional"
                error={!!errors.poNumber}
                helperText={errors.poNumber?.message}
                onChange={onChange}
              />
            )}
          />
        </Box>
      </Box>
    </form>
  );
};
